/**
 * What a region shows before there is anything in it: an icon, one line on
 * what goes here, optionally a hint and the action that fills it.
 */

import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from './styles'

interface EmptyStateProps {
    icon: LucideIcon
    title: ReactNode
    description?: ReactNode
    action?: ReactNode
    className?: string
}

export default function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
    return (
        <div
            className={cn('flex flex-col items-center justify-center rounded-2xl border border-dashed border-line-strong bg-surface px-6 py-12 text-center', className)}
        >
            <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary-soft text-primary">
                <Icon className="h-6 w-6" aria-hidden="true" />
            </span>
            <p className="text-sm font-semibold text-fg-strong">{title}</p>
            {description && <p className="mt-1 max-w-md text-sm text-fg-muted">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    )
}
